import { useState } from "react";
import CompanyTab from "@/pages/admin/settings/components/CompanyTab";
import PaymentMethodsTab from "@/pages/admin/settings/components/PaymentMethodsTab";
import PrintersTab from "@/pages/admin/settings/components/PrintersTab";
import InvoiceTab from "@/pages/admin/settings/components/InvoiceTab";
import CatalogTab from "@/pages/admin/settings/components/CatalogTab";
import FiscalTab from "@/pages/admin/settings/components/FiscalTab";
import ShortcutsTab from "@/pages/admin/settings/components/ShortcutsTab";

interface TabDef {
  key: string;
  label: string;
  icon: string;
}

const TABS: TabDef[] = [
  { key: "company", label: "Empresa", icon: "ri-building-line" },
  { key: "payments", label: "Métodos de pago", icon: "ri-wallet-3-line" },
  { key: "printers", label: "Impresoras", icon: "ri-printer-line" },
  { key: "invoices", label: "Facturas", icon: "ri-receipt-line" },
  { key: "catalog", label: "Catálogo", icon: "ri-store-3-line" },
  { key: "fiscal", label: "Fiscal", icon: "ri-government-line" },
  { key: "shortcuts", label: "Atajos POS", icon: "ri-keyboard-line" },
];

export default function AdminSettingsPage() {
  const [tab, setTab] = useState("company");

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-foreground-950">Configuración</h1>
        <p className="mt-1.5 text-sm text-foreground-500">
          Administra la empresa, el logo, los métodos de pago, las impresoras, la facturación, el
          catálogo y los datos fiscales sin tocar código.
        </p>
      </div>

      <div className="rkc-scroll-thin -mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
        {TABS.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => setTab(item.key)}
            className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${
              tab === item.key
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100"
            }`}
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className={`${item.icon} text-base`}></i>
            </span>
            {item.label}
          </button>
        ))}
      </div>

      <div className="animate-fade-in">
        {tab === "company" ? <CompanyTab /> : null}
        {tab === "payments" ? <PaymentMethodsTab /> : null}
        {tab === "printers" ? <PrintersTab /> : null}
        {tab === "invoices" ? <InvoiceTab /> : null}
        {tab === "catalog" ? <CatalogTab /> : null}
        {tab === "fiscal" ? <FiscalTab /> : null}
        {tab === "shortcuts" ? <ShortcutsTab /> : null}
      </div>
    </div>
  );
}